import { useState, useEffect } from 'react';

const useFetchEmployee = (employeeId) => {
    const [employeeData, setEmployeeData] = useState({
        name: '',
        aboutMe: '',
        role: '',
        experience: 0,
        information: {
            birthDate: '',
            country: '',
            genre: '',
            civilState: '',
            location: '',
        },
        contact: {
            phoneNumber: '',
            email: '',
        },
        conditions: {
            available: '',
            schedule: '',
        },
        experiences: [],
        educations: [],
        skills: [],
    });

    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchEmployeeProfile = async () => {
            setLoading(true);
            setError(null);

            try {
                const response = await fetch(`${process.env.REACT_APP_BACKEND_STAGING_URL}/api/employee/${employeeId}`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                });

                if (!response.ok) {
                    throw new Error('Failed to fetch employee profile');
                }

                const data = await response.json();

                const transformedData = {
                    name: data.data.name,
                    aboutMe: data.data.aboutMe,
                    role: data.data.position,
                    experience: data.data.yearsOfExperience === 'No experience' ? 0 : parseInt(data.data.yearsOfExperience, 10),
                    information: {
                        birthDate: data.data.birthDate,
                        country: data.data.country,
                        genre: data.data.genre,
                        civilState: data.data.civilState,
                        location: data.data.location,
                        region: data.data.region,
                        comune: data.data.comuna,
                        profileImageUrl: data.data.profileImageUrl
                    },
                    contact: {
                        phoneNumber: data.data.user.phoneNumber,
                        email: data.data.user.email,
                    },
                    conditions: {
                        available: data.data.available,
                        schedule: data.data.schedule,
                    },
                    experiences: data.data.experiences.map(exp => ({
                        id: exp.id,
                        companyName: exp.companyName,
                        description: exp.description,
                        startDate: exp.startDate,
                        endDate: exp.endDate,
                        role: exp.role,
                    })),
                    educations: data.data.educations.map(edu => ({
                        id: edu.id,
                        institution: edu.institution,
                        startDate: edu.startDate,
                        endDate: edu.endDate,
                        study: edu.study,
                        description: edu.description,
                    })),
                    skills: data.data.skills,
                };
                setEmployeeData(transformedData);
            } catch (error) {
                setError(error.message);
            } finally {
                setLoading(false);
            }
        };

        if (employeeId) {
            fetchEmployeeProfile();
        }
    }, [employeeId]);

    return { employeeData, loading, error };
};

export default useFetchEmployee;
